// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLanguage } from "../lib/storeManager";
import { ensureReady } from "./i18nLoader";

i18n.use(initReactI18next).init(
  {
    lng: getLanguage(),
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    load: "languageOnly",
    ns: ["common"],
    defaultNS: "common",
    // Ensure i18n is always ready with default resources
    resources: {
      en: {
        common: {},
      },
    },
  },
  async err => {
    // Always ensure empty bundle is available even if loading fails
    const currentLanguage = getLanguage();
    if (!i18n.hasResourceBundle(currentLanguage, "common")) {
      i18n.addResourceBundle(currentLanguage, "common", {}, true, true);
    }

    if (!err) {
      try {
        await ensureReady({ lng: currentLanguage, nsList: ["common"] });
      } catch (error) {
        console.error("Failed to load default translations:", error);
        // Ensure empty bundle is available on error
        if (!i18n.hasResourceBundle(currentLanguage, "common")) {
          i18n.addResourceBundle(currentLanguage, "common", {}, true, true);
        }
      }
    }
  }
);

export default i18n;
